import { createContext } from 'react';
import type { Theme } from '@newcore/ui/enums/theme';

export interface ThemeProviderState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  resolvedTheme: Theme.DARK | Theme.LIGHT;
}

export const ThemeProviderContext = createContext<
  ThemeProviderState | undefined
>(undefined);
